module.exports = __webpack_public_path__ + "img/pin7.fe0cc06d.svg";